import { render, staticRenderFns } from "./FamousRecordItem.vue?vue&type=template&id=5e965b7a&"
import script from "./FamousRecordItem.vue?vue&type=script&lang=js&"
export * from "./FamousRecordItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports